<template>
  <div
    :class="[
      'message-item',
      { own: message.isOwn, recalled: message.isRevoked },
    ]"
    :data-message-id="message.id"
  >
    <!-- 头像 -->
    <div class="avatar" v-if="!message.isRevoked && !message.isOwn">
      <img :src="avatarUrl" :alt="message.sender" />
    </div>

    <!-- 消息内容 -->
    <div class="message-content">
      <!-- 撤回消息 -->
      <div v-if="message.isRevoked" class="message-recalled">
        <i class="el-icon-info"></i>
        {{ message.content || "消息已撤回" }}
      </div>

      <template v-else>
        <!-- 消息操作菜单 -->
        <div
          v-if="message.isOwn && !message.isRevoked"
          class="message-actions"
        >

          <el-dropdown @command="handleAction" :hide-on-click="false">
            <span class="action-trigger">
              <i class="el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="recall">撤回</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <!-- 文本消息 -->
        <div
          v-if="message.type === 1"
          class="message-text"
          :data-type="message.type"
        >
          {{ message.content }}
        </div>

        <!-- 图片消息 -->
        <div v-else-if="message.type === 2" class="message-image">
          <el-image
            :src="message.content"
            :alt="message.filename || '图片'"
            :preview-src-list="[message.content]"
            style="max-width: 200px; max-height: 200px; border-radius: 4px"
            @load="onImageLoad"
          />
        </div>

        <!-- 文件消息 -->
        <div v-else-if="message.type === 3" class="message-file">
          <el-link :href="message.content" target="_blank" type="primary">
            <i class="el-icon-document"></i>
            {{ message.filename || "文件" }}
          </el-link>
        </div>

        <!-- 视频消息 -->
        <div
          v-else-if="message.type === 5 || message.type === 'VIDEO'"
          class="message-video"
          @click.stop="previewVideo(message)"
          style="position: relative; width: 150px; height: 100px; cursor: pointer; border-radius: 8px; overflow: hidden; background: #000; display: flex; align-items: center; justify-content: center;"
        >
          <video
            :src="getVideoUrl(message)"
            preload="metadata"
            style="width: 100%; height: 100%; object-fit: cover;"
          ></video>
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.2); display: flex; align-items: center; justify-content: center;">
            <i class="el-icon-video-play" style="font-size: 32px; color: #fff; text-shadow: 0 2px 4px rgba(0,0,0,0.5);"></i>
          </div>
        </div>

        <!-- 系统消息 -->
        <div v-else-if="message.type === 0" class="message-system">
          {{ message.content }}
        </div>
      </template>

      <!-- 时间戳 -->
      <div class="message-time" v-if="message.createTime">
        {{ message.createTime }} <span v-if="message.isOwn">{{ message.isRead ? '已读' : '未读' }}</span>
      </div>

      <!-- 发送状态 -->
      <!-- <div v-if="message.isOwn && message.status" class="message-status">
        <i :class="statusIcon" :style="{ color: statusColor }"></i>
      </div> -->
    </div>

     <!-- 头像 -->
    <div class="avatar" v-if="!message.isRevoked && message.isOwn">
      <img :src="avatarUrl" :alt="message.sender" />
    </div>
  </div>
</template>

<script>
import kefuH from "@/assets/images/serviddepng.png";
import userH from "@/assets/images/defaultavatar.png";
export default {
  name: "MessageItem",
  props: {
    message: {
      type: Object,
      required: true,
    },
    conversation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showViewer: false,
      previewList: [],
      currentIndex: 0,
    };
  },
  computed: {
    avatarUrl() {
      // 这里可以根据用户类型返回不同的头像
      if (this.message.isOwn) {
        return kefuH; // 客服头像
      } else {
        return userH; // 用户头像
      }
    },
    statusIcon() {
      switch (this.message.status) {
        case "sending":
          return "el-icon-loading";
        case "sent":
          return "el-icon-check";
        case "failed":
          return "el-icon-close";
        default:
          return "";
      }
    },
    statusColor() {
      switch (this.message.status) {
        case "sent":
          return "#67c23a";
        case "failed":
          return "#f56c6c";
        default:
          return "#909399";
      }
    },
  },
  methods: {
    formatTime(timestamp) {
      if (!timestamp) return "";

      const date = new Date(timestamp);
      const now = new Date();
      const diff = now - date;

      // 如果是今天的消息，只显示时间
      if (diff < 24 * 60 * 60 * 1000) {
        return date.toLocaleTimeString("zh-CN", {
          hour: "2-digit",
          minute: "2-digit",
        });
      }

      // 如果是昨天的消息
      if (diff < 2 * 24 * 60 * 60 * 1000) {
        return (
          "昨天 " +
          date.toLocaleTimeString("zh-CN", {
            hour: "2-digit",
            minute: "2-digit",
          })
        );
      }

      // 其他日期显示完整日期
      return (
        date.toLocaleDateString("zh-CN") +
        " " +
        date.toLocaleTimeString("zh-CN", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    },
    isRecentMessage(message) {
      const messageTime = new Date(message.createTime);
      const now = new Date();
      const diffMinutes = (now - messageTime) / (1000 * 60);

      return diffMinutes <= 3;
    },
    handleAction(command) {
      switch (command) {
        case "recall":
          this.recallMessage();
          break;
      }
    },
    recallMessage() {
      // 触发撤回消息事件
      this.$emit("recall-message", this.message.id);
    },

    onImageLoad() {
      this.$emit("scrollToBottom")
    },
    getVideoUrl(message) {
      if (message.type === 5 || message.type === 'VIDEO') {
        if (typeof message.content === "object" && message.content.url) {
          return message.content.url;
        }
        return message.content;
      }
      return "";
    },
    previewVideo(message) {
      const videoUrl = this.getVideoUrl(message);
      if (videoUrl) {
        this.createVideoPreviewLayer(videoUrl);
      }
    },
    createVideoPreviewLayer(videoUrl) {
      // 如果已经存在预览层，先移除
      const existingPreview = document.getElementById('global-video-preview');
      if (existingPreview) {
        document.body.removeChild(existingPreview);
      }

      // 创建预览层容器
      const previewContainer = document.createElement('div');
      previewContainer.id = 'global-video-preview';
      previewContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.9);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        animation: fadeIn 0.3s ease;
      `;

      // 创建视频容器
      const videoContainer = document.createElement('div');
      videoContainer.style.cssText = `
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
      `;

      // 创建视频元素
      const video = document.createElement('video');
      video.src = videoUrl;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.webkitPlaysInline = true;
      video.style.cssText = `
        max-width: 100%;
        max-height: 100%;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        outline: none;
      `;

      // 创建关闭按钮
      const closeButton = document.createElement('div');
      closeButton.innerHTML = '×';
      closeButton.style.cssText = `
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 24px;
        cursor: pointer;
        z-index: 10000;
        transition: all 0.3s ease;
        border: 1px solid rgba(255, 255, 255, 0.2);
      `;

      // 关闭事件
      const closePreview = () => {
        previewContainer.style.animation = 'fadeOut 0.3s ease';
        setTimeout(() => {
          if (document.body.contains(previewContainer)) {
            document.body.removeChild(previewContainer);
          }
        }, 280);
      };

      closeButton.addEventListener('click', closePreview);
      previewContainer.addEventListener('click', (e) => {
        if (e.target === previewContainer || e.target === videoContainer) {
          closePreview();
        }
      });

      videoContainer.appendChild(video);
      videoContainer.appendChild(closeButton);
      previewContainer.appendChild(videoContainer);
      document.body.appendChild(previewContainer);
    },
   
  },
};
</script>

<style scoped>
.message-item {
  display: flex;
  margin-bottom: 16px;
  max-width: 100%;
}

.message-item.own {
  justify-content: flex-end;
}

.message-item.recalled {
  justify-content: center;
  opacity: 0.6;
}

.message-content {
  max-width: 70%;
  margin: 0 12px;
  position: relative;
}

.message-text {
  padding: 8px 12px;
  border-radius: 8px;
  word-break: break-word;
  position: relative;
  white-space: pre-wrap;
}

.message-item:not(.own) .message-text {
  background: #fff;
  color: #333;
  border-top-left-radius: 4px;
}

.message-item.own .message-text {
  background: #409eff;
  color: white;
  border-top-right-radius: 4px;
}

.message-image {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  padding: 8px;
}

.message-file {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
}

.message-system {
  background: #fff3cd;
  color: #856404;
  border-radius: 8px;
  padding: 8px 12px;
  text-align: center;
  font-size: 14px;
}

.message-time {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.message-item:not(.own) .message-time {
  text-align: left;
}

.message-item.own .message-time {
  text-align: right;
}

.message-status {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 撤回消息样式 */
.message-recalled {
  padding: 8px 12px;
  border-radius: 8px;
  background: #f5f5f5;
  color: #909399;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ebeef5;
}

.message-recalled i {
  margin-right: 4px;
}

/* 消息操作菜单样式 */
.message-actions {
  position: absolute;
  top: -8px;
  right: -8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 99;
}

.message-item:hover .message-actions {
  opacity: 1;
}

.action-trigger {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.2s ease;
}

.action-trigger:hover {
  background: rgba(0, 0, 0, 0.8);
}
</style>
